// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#css__iOxuns{background-color:var(--theme_white);position:relative;z-index:1}.css__rJG63d{height:100vh}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "css__iOxuns",
	"default_page": "css__rJG63d"
};
module.exports = ___CSS_LOADER_EXPORT___;
